import { matchPath, useLocation } from 'react-router-dom';
import { useUserRoles } from './';
import { DynamicRoute, routes, PossibleUrlParams } from '../constants/routes';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { BusinessUnit, Role } from '@cambridgeassessment/lib-ee-commons';

export const useDynamicRoutes = (
  selectedRole: Role | null,
  businessUnitId?: BusinessUnit['id'],
): DynamicRoute[] | [] => {
  const location = useLocation();
  const userRoles = useUserRoles();
  const state = useSelector((rootState: RootState) => rootState) || [];
  if (!selectedRole || !businessUnitId) {
    return [];
  }

  const dynamicRoutes = userRoles
    ? routes
        .map((route) => {
          const isAvailableForBU = route.availableForBU.includes(businessUnitId);
          if (!isAvailableForBU) {
            return null;
          }
          const userCanAccess = route.canAccess ? route.canAccess?.includes(selectedRole?.name) : true;
          const match = matchPath<{ [key in PossibleUrlParams]: string }>(location.pathname, {
            path: route.path,
          });

          if (userCanAccess) {
            return {
              ...route,
              selected: !!match,
              title: route.titleResolver ? route.titleResolver(state, match) : route.title,
              path: route.pathResolver ? route.pathResolver(state, match) : route.path,
            };
          }
          return null;
        })
        .filter((route) => route)
    : [];

  return dynamicRoutes as DynamicRoute[] | [];
};
